let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("lDwxv")).then(() => parcelRequire('bhSzo'));